import { ChevronRightIcon } from "@/components/ChevronRightIcon";

export type Crumb = {
  label: string;
  /** If set (and not the last crumb), the crumb renders as a button that navigates back. */
  onClick?: () => void;
};

/** Thin breadcrumb bar, e.g. Company name › Facility name › Daily. */
export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex shrink-0 items-center gap-1.5 overflow-hidden border-b border-gray-200 bg-white px-4 py-2 text-sm"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const clickable = Boolean(item.onClick) && !isLast;
        return (
          <span key={index} className="flex min-w-0 items-center gap-1.5">
            {index > 0 && (
              <ChevronRightIcon className="h-3.5 w-3.5 shrink-0 text-gray-400" />
            )}
            {clickable ? (
              <button
                type="button"
                onClick={item.onClick}
                title={item.label}
                className="max-w-[14rem] truncate hover:text-gray-700"
              >
                {item.label}
              </button>
            ) : (
              <span title={item.label} className="max-w-[14rem] truncate">
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
